import {
  Component,
  computed,
  input,
  output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';

export interface NonBlockingErrorConfiguration {
  errorMessage: string;
  isClosable: boolean;
}

export interface BlockingErrorConfiguration {
  errorMessage: string;
  errorHeader: string;
}

@Component({
  selector: 'conn-encompass-forms-error',
  imports: [],
  templateUrl: './encompass-forms-error.component.html',
  styleUrl: './encompass-forms-error.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class EncompassFormsErrorComponent {
  nonBlockingErrorConfig = input<NonBlockingErrorConfiguration | null>(null);
  blockingErrorConfig = input<BlockingErrorConfiguration | null>(null);
  isNonBlockingErrorDismissed = signal(false);
  nonBlockingErrorDismissed = output<string>();

  displayedNonBlockingError = computed(() => {
    if (this.blockingErrorConfig() !== null) {
      return false;
    }

    if (this.nonBlockingErrorConfig() === null) {
      return false;
    }

    if (this.isNonBlockingErrorDismissed()) {
      return false;
    }

    return true;
  });

  contactMailtoHref = computed(() => {
    const subject = encodeURIComponent(
      `Dynamic Forms Error; Error Info: ${this.blockingErrorConfig()?.errorMessage ?? ''}`,
    );
    return `mailto:customercare@eyefinity.com?subject=${subject}`;
  });

  dismissNonBlockingError() {
    this.isNonBlockingErrorDismissed.set(true);
    this.nonBlockingErrorDismissed.emit(
      this.nonBlockingErrorConfig().errorMessage,
    );
  }
}
